import type { FC } from 'react';

export const Thumbnail: FC<{ thumbnail: string; style?: React.CSSProperties }> = ({
  thumbnail,
  style,
}) => {
  return (
    <div
      style={{
        position: 'relative',
        backgroundImage: `url(${thumbnail})`,
        height: 48,
        width: 48,
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        borderRadius: 12,
        backgroundColor: !thumbnail ? '#F7F4ED' : '',
        ...style,
      }}
    />
  );
};
